import request_api from "../../core/request_api";
import Swal from "sweetalert2";

const state = {
  currentAct: {
    isLoading: false,
    hideModal: false,
  }
};
const getters = {
  getCurrentAct(state) {
    return state.currentAct
  }
};
const mutations = {
  CURRENTACT_START(state, payload) {
    return (state.currentAct = payload)
  }
};
const actions = {
  registrationStart({ commit }, data_regist) {

    const tempData = {
      type_regis: data_regist.typeAcc,
      full_name: data_regist.name,
      email: data_regist.email,
      company: data_regist.company,
      country: data_regist.country,
      // state: data_regist.state,
      // city: data_regist.city,
      password: data_regist.password,
      // date_of_birth: "1997-09-03", //Deleted soon
    };
    commit("CURRENTACT_START", {isLoading: true, hideModal: false})
    request_api()
      .post("registration", tempData)
      .then((res) => {
        const meta = res.data;
        if (meta.code === 200) {
          Swal.fire({
            icon: "success",
            title: "Good Job!",
            text: meta.message,
            onAfterClose () {
              commit("CURRENTACT_START", {isLoading: false, hideModal: true})
            }
          });
        }
      })
      .catch((err) => {
        // console.log(err)
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.response.data.message,
          onAfterClose () {
            commit("CURRENTACT_START", {isLoading: false, hideModal: false})
          }
        });
      });
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
